/* eslint-disable no-param-reassign */
import React, { Suspense, useState } from 'react';
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
  Link,
  SkeletonLine
} from '@one-thd/sui-atomic-components';
import { useDrawer } from '../../hooks/use-drawer';
import { FAQ_TITLE } from '../../utils/verbiage';
import { FAQ } from '../../utils/consts';

const QUESTIONS_KEYS = Object.keys(FAQ);

const FAQDrawerContent = () => {
  const [expanded, setExpanded] = useState('');

  const handleExpandChange = (_componentFileName: string) => {
    if (!FAQ[_componentFileName]?.component) {
      FAQ[_componentFileName].component = React.lazy(
        () => import(`./answers/${_componentFileName}`)
      );
    }
    setExpanded((prevExpanded) => (prevExpanded === _componentFileName ? '' : _componentFileName));
  };

  return (
    <div className="sui-w-full sui-flex sui-flex-col sui-gap-1">
      {QUESTIONS_KEYS.map((componentFileName) => {
        const question = FAQ[componentFileName];
        if (!question) {
          return null;
        }
        const { title } = question;
        return (
          <Accordion
            key={componentFileName}
            expanded={expanded === componentFileName}
            onChange={() => handleExpandChange(componentFileName)}
          >
            <AccordionHeader data-testid="faq-title">{title}</AccordionHeader>
            <AccordionBody>
              <Suspense
                fallback={(
                  <div className="sui-w-full" data-testid="faq-loader">
                    <SkeletonLine variant="single" />
                  </div>
                )}
              >
                {question?.component && <question.component />}
              </Suspense>
            </AccordionBody>
          </Accordion>
        );
      })}
    </div>
  );
};

const FrequentlyAskedQuestions = () => {
  const { openDrawer } = useDrawer();

  const handleOpenDrawer = () => {
    openDrawer({
      title: FAQ_TITLE,
      ContentComponent: FAQDrawerContent,
      hideFooter: true
    });
  };

  return (
    <Link component="button" onClick={handleOpenDrawer} href="#basic-link">
      {FAQ_TITLE}
    </Link>
  );
};

export { FrequentlyAskedQuestions };
